import React, { Component } from "react";
import Dialog from "material-ui/Dialog";
import { connect } from "react-redux";
import moment from 'moment';
import classNames from 'classnames';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import { CancelButton } from "../../../../../../../../components/buttons";
import { getSkillAcqCollectedData} from "./actions/targetsActionNewFlow";
import { change, Field, reduxForm } from 'redux-form';
import {renderCheckBox, renderDateField ,renderTimePicker, renderAutoCompleteSingleSelect} from "../../../../../../../../components/reduxFields";
import { getPromptCodeList } from "../../../../../DataCollection/SetUp/promptCodes/actions/PromptCodeActions";
import { updateSkillAcaCollectedDTTDataAction ,updateSkillAcqCollectedDTTDataPromtCodeAction, deleteSkillAcqCollectedDTTData} from "../../../../../DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions";
import Sorting from "../../../../../../../../components/SortingCustom";


const styleCss = {
    checkbox: {
        marginBottom: 16,
    },
};

class CollectDTTData extends Component {
    constructor(props) {
    super(props);
    this.state = {
        isModelOpen : true,
        patientId: props.patientId,
        // skillsAcquisitionTargetId: props.skillsAcquisitionTargetId,
        // skillsAcquisitionProgramId: props.skillsAcquisitionProgramId,
        collectedDataId:props.collectedDataId,
        targetType:props.targetType,
        selectedTargetIds: [],
        sessionDate: [],
        sessionTime: [],
    };
    this.setSortColumn = this.setSortColumn.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
}

handleClose = () => {
    if (this.state.isModelOpen) {
    this.setState({ open: false });
    this.props.closeDialog();
    }
};

componentWillMount(){
    let searchObj = {
        contain_filters: { patientId: this.state.patientId || null },
        pageNumber: 1,
    };
    this.props.getPromptCodeList(searchObj);
}
componentDidMount(){
  this.props.getSkillAcqCollectedData(this.state.patientId, this.state.collectedDataId, this.state.targetType)
}


componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.keyCode === 27) {
            self.handleClose();
        }
    };
    if (nextProps.todaysCollectedData && nextProps.todaysCollectedData.data && nextProps.todaysCollectedData.data.PatSkillsAcqAllCollectedDataModel) {
        
         let sessionDate1 = this.state.sessionDate;
         let sessionTime1 = this.state.sessionTime;
        (nextProps.todaysCollectedData.data.PatSkillsAcqAllCollectedDataModel || []).forEach((obj, index) => {               
            _.update(sessionDate1, `[${obj.id}]`, function(n) {
                return moment(obj.sessionDate).format('MM-DD-YYYY');
            });                
            this.props.dispatch(change('todaysCollectedDataForm', `Target[${index}].sessionDate`, moment(obj.sessionDate).format('MM-DD-YYYY')  || null));

            _.update(sessionTime1, `[${obj.id}]`, function(n) {                    
                return moment(obj.sessionDate).format('YYYY-MM-DD') + 'T' + moment(obj.sessionDate).format('HH:mm:ss');
            });                
            this.props.dispatch(change('todaysCollectedDataForm', `Target[${index}].sessionTime`, moment(obj.sessionDate).format('HH:mm:ss') || '00:00:00'));
        });
         this.setState({sessionDate: sessionDate1, sessionTime: sessionTime1 });

        (nextProps.todaysCollectedData.data.PatSkillsAcqAllCollectedDataModel || []).forEach((obj, index) => {
            this.props.dispatch(change('todaysCollectedDataForm', `Target[${index}].id`, obj.staffId || null));
        });

        (nextProps.todaysCollectedData.data.PatSkillsAcqAllCollectedDataModel || []).forEach((obj, index) => {
            this.props.dispatch(change('todaysCollectedDataForm', `Target[${index}].status`, obj.statusId || null));
        });
        (nextProps.todaysCollectedData.data.PatSkillsAcqAllCollectedDataModel || []).forEach((obj, index) => {
            this.props.dispatch(change('todaysCollectedDataForm', `Target[${index}].promptCode`, obj.promptCodeId || null));
        });
    }

}

onDateChange = (input, value, skillsAcquisitionTargetId, action) => {
    input.onChange(moment(value).format());

    let sessionDate1 = this.state.sessionDate;

    _.update(sessionDate1, `[${skillsAcquisitionTargetId}]`, function(n) {
        return moment(value).format('YYYY-MM-DD');
    });

    this.setState({
        sessionDate: sessionDate1,           
    }, ()=>{          

        let sessionDate =  moment(this.state.sessionDate[skillsAcquisitionTargetId]).format('YYYY-MM-DD') + 'T' + moment(this.state.sessionTime[skillsAcquisitionTargetId]).format('HH:mm:ss');            
        this.props.updateSkillAcaCollectedDTTDataAction(skillsAcquisitionTargetId, sessionDate, 0, 0, this.state.patientId, this.state.targetId, action)
    });
}

onTimeChange = (input, value, skillsAcquisitionTargetId, action) => {
    input.onChange(moment(value).format());
    
    let sessionTime1 = this.state.sessionTime;

    _.update(sessionTime1, `[${skillsAcquisitionTargetId}]`, function(n) {
        return  moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    this.setState({         
        sessionTime: sessionTime1,
    }, ()=>{
        let sessionDate =  moment(this.state.sessionDate[skillsAcquisitionTargetId]).format('YYYY-MM-DD') + 'T' + moment(this.state.sessionTime[skillsAcquisitionTargetId]).format('HH:mm:ss');            
        this.props.updateSkillAcaCollectedDTTDataAction(skillsAcquisitionTargetId, sessionDate, 0, 0, this.state.patientId, this.state.targetId, action)
    });
}

handleNewRequestStatus = (input, selectedRecord, skillsAcquisitionTargetId, action) => {

    input.onChange(selectedRecord.value);
    this.props.updateSkillAcaCollectedDTTDataAction(skillsAcquisitionTargetId, moment().format('YYYY-MM-DDTHH:mm:ss') , selectedRecord.value, selectedRecord.value, this.state.patientId, this.state.skillsAcquisitionTargetId, action)
};

handleNewRequestPromptCode = (input, selectedRecord, skillsAcquisitionTargetId) => {
    input.onChange(selectedRecord.value);
    this.props.updateSkillAcqCollectedDTTDataPromtCodeAction(skillsAcquisitionTargetId, selectedRecord.value, this.state.patientId, this.state.skillsAcquisitionTargetId)
};

// handleDeleteTarget = () => {
//     this.props.deleteSkillAcqCollectedDTTData(this.state.selectedTargetIds, this.state.patientId, this.state.targetId)
//     this.setState({
//         selectedTargetIds : []
//     });
// }

setSortColumn(col_name, col_order) {
    if (col_name) {
        this.filter.sort_Column = col_name;
        this.filter.sort_order = col_order;
        this.loadData();
    }
}

checkTargets = (e, index, obj) => {
    let selectedTargetIds = this.state.selectedTargetIds;
    let isTargetChecked = e.target.checked;
    if (isTargetChecked) {
        if (obj.id) {
            selectedTargetIds.push(obj.id);
        }
    } else {
        if (obj.id) {
            index = selectedTargetIds.findIndex((value) => value === obj.id);
            if (index >= 0) {
                selectedTargetIds.splice(index, 1);
            }
        }
    }
    this.setState({
        selectedTargetIds: selectedTargetIds
    });
}


renderData = (collectDataList) => {
    collectDataList = collectDataList || [];

    if (!collectDataList.length) {
        return (
            <tr>
                <td colSpan="6">
                    <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                </td>
            </tr>
        );
    }

    return collectDataList.map((data, index) => {
        return (
            <tr key={index}>
               <td>
                    <Field
                    name={`Target[${index}].sessionDate`}
                    locale="en-US"
                    selected={this.state.sessionDate[data.id]}
                    onDateChange={(input, value) => this.onDateChange(input, value, data.id, 'SESSIONDATE')}                       
                    openToYearSelection={true}
                    component={renderDateField}
                />
               </td>
               <td>
                    <Field
                        name={`Target[${index}].sessionTime`}
                        //placeholder="Time"
                        fullWidth={true}            
                        selected={this.state.sessionTime[data.id]}                       
                        component={renderTimePicker}
                        onDateChange={(input, value) => this.onTimeChange(input, value, data.id, 'SESSIONDATE')}                                      
                    />
                </td>
                <td>
                    <Field
                        name={`Target[${index}].id`}
                        hintText="Staff Name"
                        handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, data.id, 'STAFFID')}
                        options={this.props.allStaffs}
                        component={renderAutoCompleteSingleSelect}
                    />
                </td>
                <td>
                    <Field
                        name={`Target[${index}].status`}
                        hintText="Status"
                        handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, data.id, 'STATUS')}
                        options={this.props.masterTargetStatusWithoutReady}
                        component={renderAutoCompleteSingleSelect}
                    />
                </td>
                
                <td>
                    <Field
                        name={`Target[${index}].promptCode`}
                        hintText="Prompt Code"
                        handleNewRequest={(input, selectedValue) => this.handleNewRequestPromptCode(input, selectedValue, data.id)}
                        options={this.props.promptCodeListData.data}
                        component={renderAutoCompleteSingleSelect}
                    />
                </td>
                {/* <td>
                    <div className="table_custom-check">
                        <Field
                            name={`CheckTarget[${data.id}${index}].Chk`}
                            component={renderCheckBox}
                            onChange={(e) => this.checkTargets(e, index, data)}
                            style={styleCss.checkbox}
                        />
                    </div>
                </td> */}
            </tr>
        );
    })
}


render() {
    const {todaysCollectedData} = this.props;
    let collectDataList = (todaysCollectedData && todaysCollectedData.data.PatSkillsAcqAllCollectedDataModel) || [];
    const tableClass = classNames({
        'table': true,
        'table-striped': this.props.bordered,
        'table-bordered': this.props.bordered,
        'table-hover': true,
        'table-condensed': this.props.condensed,
        'customtable': true,
        'suptable': true,
    });
    const actions = [
        // <RaisedButton
        // disabled={this.state.selectedTargetIds.length > 0 ? false : true}  
        // className="mr-15"                          
        // label="Delete Data"
        // primary={true}
        // onTouchTap={() => this.handleDeleteTarget()} />,
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
    ];
    // console.log(this.props, "props")
    return(
        <Dialog 
        className="custom_modal_new_appointment"
        title="COLLECT DTT DATA"
        modal={false} open={this.state.isModelOpen} autoScrollBodyContent={true}
        actions={actions}
        >
            <div className="table-responsive mt-15">
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="15%">
                            {<Sorting noSort={!collectDataList.length} setSortColumn={this.setSortColumn} columnName='sessionDate' displayName='Session Date' />}
                            </th>
                            <th width="10%">Time</th>
                            <th width="20%">
                            {<Sorting noSort={!collectDataList.length} setSortColumn={this.setSortColumn} columnName='staffName' displayName='Staff Name' />}
                            </th>
                            <th width="13%">Status</th>
                            <th width="12%">Prompt Code</th>
                            {/* <th width="10%">
                                Delete
                            </th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData(collectDataList)}
                    </tbody>
                </table>
            </div>
        </Dialog>
    )
}


}

CollectDTTData = reduxForm({
    form: 'todaysCollectedDataForm',
    enableReinitialize: true,
})(CollectDTTData);

function mapStateToProps(state, ownProps) {
    // console.log(state.skillAcquisitionDomain, "state skillAcquisitionDomain console")
    return {
        loading: state.patientSkillAcqActiveTarget.loading,
        todaysCollectedData: state.patientSkillAcqActiveTarget.todaysCollectedData,
        masterTargetStatusWithoutReady: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.targetStatusWithoutReady : [],
        promptCodeListData: state.patient_prompt_code.promptCodeList !== null ? state.patient_prompt_code.promptCodeList : [],
        allStaffs : state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.allStaffsActiveAndInactive : [],
    }
}

export default connect(mapStateToProps, {
    getSkillAcqCollectedData,
    getPromptCodeList,
    deleteSkillAcqCollectedDTTData,
    updateSkillAcaCollectedDTTDataAction,
    updateSkillAcqCollectedDTTDataPromtCodeAction
   })(CollectDTTData);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Maintenance/components/targets/CollectDTTData.js